import React from 'react'

const Copyright = () => {
  return (
    <div style={{ background: '#15161D' }}>
      <div className='w-full h-24 text-gray-400 pb-2 bg-opacity-10 bg-gray-500 flex justify-center items-end'>
        Copyright ©2022 All rights reserved
      </div>
    </div>
  )
}

export default Copyright
